import { createSlice } from "@reduxjs/toolkit";
import { httpGet } from "../../utils/Rest";

const initialData = {
  totalProjectionsData: [],
  totalAdminProjectionsData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: "TotalProjections", //Reference Name, It can be anything
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    updateProjectionsData: (state, action) => {
      state.totalProjectionsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    updateAdminProjectionsData: (state, action) => {
      state.totalAdminProjectionsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  updateProjectionsData,
  updateAdminProjectionsData,
  fetchStart,
  fetchError,
  fetchSuccess,
} = slice.actions;

export const fetchTotalProjections = (connectorId, productType, freqValue) => {
  return (dispatch) => {
    dispatch(fetchStart());
    let url = `total/connector/${connectorId}`;
    url = productType !== "" || freqValue ? `${url}?` : url;
    url = productType !== "" ? url + `product=${productType}` : url;
    url = productType !== "" && freqValue ? `${url}&` : url;
    url = url + `timeframe=${freqValue}`;

    httpGet(url)
      .then((res) => {
        // console.log(res, ":projections data");
        if (res?.status === 200) {
          dispatch(updateProjectionsData(res.data));
          dispatch(fetchSuccess());
        } else {
          dispatch(fetchError(res.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchAdminTotalProjections = (productType, bankName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    let url = `total/finadmin`;
    url = productType || bankName !== "" ? `${url}?` : url;
    url = productType ? url + `product=${productType}` : url;
    url = productType && bankName ? `${url}&` : url;
    url = bankName !== "" ? url + `bank=${bankName}` : url;

    httpGet(url)
      .then((res) => {
        if (res?.status === 200) {
          dispatch(updateAdminProjectionsData(res?.data));
          dispatch(fetchSuccess());
        } else {
          dispatch(fetchError(res.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
